<template>
  <div id="app">
  <!--Header-nav-->
  <div class="header_block container-fluid sticky-top d-flex justify-content-between">
    <div class="header_item_left col-12 col-lg-12 col-xl-9 p-0">
      <div id="index_filter" class="pofx bg-filter dp-n" style="width:105%;height:105vh;z-index:4;top:-20px;left:-20px;"></div>
      <div id="nav_flex_blcok" class="dp-flex flow-hn aic jcs">
        <a href="javascript:void(0);">
          <div class="top_menu_btn">
            <div class="top_menu_btn_icon">
              <div class="btn_bar"></div>
              <div class="btn_bar"></div>
              <div class="btn_bar"></div>
            </div>
          </div>
        </a>
        <div id="logo">
          <a href="javascript:$('html, body').stop().animate({scrollTop: 0}, 500);"><img src="./assets/header/tl_invest_logo.png" alt="" title="" class="img-fluid" /></a>
        </div>
        <nav id="nav-menu-container">
        <!--中文MENU-->
          <ul class="nav-menu">
            <router-link :to="{name: 'home'}" tag="li">首頁</router-link>
            <!--<router-link :to="{name: 'exhibit_info'}" tag="li" class="menu-has-children">展覽資訊
              <ul>
                <router-link :to="{name: 'home'}" tag="li">論壇活動</router-link>
                <router-link :to="{name: 'home'}" tag="li">歷屆參展品牌</router-link>
              </ul>
            </router-link>-->
            <router-link :to="{name: 'hotel'}" tag="li">特約飯店</router-link>
            <router-link :to="{name: 'transport'}" tag="li">展館介紹</router-link>
            <router-link :to="{name: 'contractor'}" tag="li">協力廠商</router-link>
            <router-link :to="{name: 'partners'}" tag="li">合作單位</router-link>
            <router-link :to="{name: 'member'}" tag="li" class="menu-has-children">會員專區
              <ul>
                <router-link :to="{name: 'home'}" tag="li">會員登出</router-link>
                <router-link :to="{name: 'record'}" tag="li">報名參展紀錄</router-link>
                <router-link :to="{name: 'modify'}" tag="li">修改公司資訊/密碼</router-link>
              </ul>
            </router-link>
            <router-link :to="{name: 'contract'}" tag="li">聯絡我們</router-link>
          </ul>
        <!--英文MENU-->
          <ul class="nav-menu nav_eng">
            <a href="#about_us"><li>ABOUT US</li></a>
            <a href="#exhibition"><li>EXHIBITION</li></a>
            <a href="#transportation"><li>TRANSPORTATION</li></a>
            <a href="#hotelaccom"><li>ACCOMMODATION</li></a>
            <a href="#partners" style="display:none;"><li>PARTNERS</li></a>
          </ul>
        </nav><!-- #nav-menu-container -->
        <!--Side Menu-->
        <div class="side_menu poab" style="z-index:5;">
          <div class="side_menu_banner ta-c">
            <img src="./assets/header/tl_invest_logo.png" alt="mobile_top_banner">
          </div>
          <!--Side 英文-->
          <div class="side_menu_list">
            <ul class="nav_eng">
              <a href="#about_us"><li>ABOUT US</li></a>
              <a href="#exhibition"><li>EXHIBITION</li></a>
              <a href="#transportation"><li>TRANSPORTATION</li></a>
              <a href="#hotelaccom"><li>ACCOMMODATION</li></a>
              <a href="#partners" style="display:none;"><li>PARTNERS</li></a>
              <a href="#app" style="color:#ff45cd;"><li><i class="fa fa-undo"></i> RETURN</li></a>
            </ul>
          </div>

        </div>
      </div>
    </div>
    <div class="header_item_right col-lg-3 col-xl-3 p-0 align-items-center justify-content-lg-end">
      <div class="lang_flex_block mx-1">
        <div class="d-lg-flex align-items-center">
          <router-link :to="{name: 'home_eng'}" style="color:#fff;"><button id="lang_eng" class="lang_item btn btn-secondary btn-sm mx-1" style="width:35px;" >EN</button></router-link>
          <a href="http://www.top-link.com.tw/" style="color:#fff;"><button id="lang_chi" class="lang_item btn btn-secondary btn-sm mx-1" style="width:35px;" >中</button></a>
        </div>
      </div>
      <div id="topSearchBox" class="searchBox_flex_block">
        <div class="form-row">
          <div class="col">
            <input type="text" class="form-control" placeholder="全站搜尋">
          </div>
          <div class="col">
          <select id="inputState" class="form-control">
            <option selected>依產業搜尋</option>
            <option>...</option>
          </select>
          </div>
        </div>
      </div>
    </div>

  </div><!-- //Header-nav-->

    <!--元件container-->
    <div class="" style="min-height:100vh;">
      <!--呈現元件的地方-->
      <router-view></router-view>
    </div><!--元件container-->


<!-- Footer -->
<footer class="container-fluid py-4">
  <div class="d-flex justify-content-center">
    <div class="footer_icon"><img src="./assets/footer/icon_01.png" class="img-fluid"></div>
    <div class="footer_icon"><img src="./assets/footer/icon_02.png" class="img-fluid"></div>
    <div class="footer_icon"><img src="./assets/footer/icon_03.png" class="img-fluid"></div>
    <div class="footer_icon"><img src="./assets/footer/icon_04.png" class="img-fluid"></div>
    <div class="footer_icon"><img src="./assets/footer/icon_05.png" class="img-fluid"></div>
  </div>
  <div class="mb-3">
    努力打造國內第一最大規模的專業展覽公司的品牌<br>
    堅持以ｌ專業ｌ展覽的Know How、國際接軌的ｌ創意ｌ思維，及展覽執行的ｌ實力ｌ，貼近廠商、民眾及消費通路的多元服務需求。
  </div>
  <div class="footer_copyRight_blcok">Copyrights © 2018 All Rights Reserved by Top-Link. </div>
</footer>
<footer class="container-fluid py-4">
  <div class="mb-3">
    <h3 style="padding:20px 0 0 0;font-family:'Roboto Slab';">Contact Us</h3>
    <div class="company_info row max-w-lg mg-auto">
      <div class="col-md-6 col-sm-12">
        <p class="ta-l max-w-sm" style="margin:20px auto;"><b style="letter-spacing:1.2px;">Taipei Office</b><br>
          4F., No.550, Sec. 5, Zhongxiao E. Rd., Xinyi Dist., Taipei City 110, Taiwan (R.O.C.)<br>
          TEL:+886 2-2759-7167<br>FAX:+886 2-2759-7167</p>
      </div>
      <div class="col-md-6 col-sm-12">
        <p class="ta-l max-w-sm" style="margin:20px auto;"><b style="letter-spacing:1.2px;">Kaohsiung Office</b><br>
          Rm. 2, 17F., No.110, Sanduo 4th Rd., Lingya Dist., Kaohsiung City 802, Taiwan (R.O.C.)<br>
          TEL:+886 7-331-0188<br>FAX:+886 7-331-0877</p>
      </div>
    </div>
  </div>
  <div class="footer_copyRight_blcok">Copyrights © 2018 All Rights Reserved by Top-Link. </div>
</footer>
<!-- //Footer-->

  </div>
</template>

<script>
export default {
  name: "main",
  components: {},
  created() {
    this.$http.get("https://randomuser.me/api/").then(response => {
      // console.log(response.data);
    });
  }
};
</script>

<style>
body{ font-family: 'Microsoft JhengHei';}
/*Header*/
.header_block{
  padding-bottom: 20px; padding-top: 20px; background-color:#fff; box-shadow: 0px 3px 10px #e7e7e7;
}
#logo {
  max-width: 130px;
}

#nav-menu-container {
  margin: 0 20px;
}
/* Nav Menu Essentials */
.nav-menu,
.nav-menu * {
  margin: 0;
  padding: 0;
  list-style: none;
}
.nav-menu ul {
  position: absolute;
  display: none;
  top: 100%;
  right: 0;
  z-index: 99;
}
.nav-menu li {
  position: relative;
  white-space: nowrap;
  cursor: pointer;
}
.nav-menu > li {
  float: left;
}
.nav-menu li:hover > ul,
.nav-menu li.sfHover > ul {
  display: block;
}
.nav-menu ul ul {
  top: 0;
  right: 100%;
}
.nav-menu ul li {
  max-width: 180px;
}

/* header_item */
.header_item_right {
  display:flex;
}
/* Nav Meu Styling */
.nav-menu a {
  padding: 0 4px 0px 4px;
  text-decoration: none;
  display: inline-block;
  color: #222;
  font-weight: 500;
  font-size: 1rem;
  text-transform: uppercase;
  outline: none;
}
.nav-menu li:hover {
  color: #8490ff;
}
.nav-menu > li {
  margin-left: 10px;
  padding: 5px 10px;
  font-size:18px;
}
.nav-menu ul {
  margin: 0;
  padding: 10px;
  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
  background: #fff;
  left: 0;
  width: 180px;
}
.nav-menu ul li {
  padding: 5px 10px;
  color: #333;
  transition: 0.3s;
  display: block;
  font-size: 1rem;
  text-transform: none;
}
.nav-menu ul ul {
  margin-right: 10px;
  margin-top: 0;
}

/* top_menu_btn */
.top_menu_btn {
  position:absolute;
  display:none;
  align-items:center;
  justify-content:center;
  width:50px;
  height:50px;
  left:0;
  top:-8px;
}
.top_menu_btn_icon {
  width:60%;
}
.btn_bar {
  width:100%;
  border-top:5px solid #00abec;
  margin-top:5px;
}

/* Side_menu */
.side_menu {
  width:300px;
  background:white;
  border:1px solid rgb(226, 226, 226);
  height:100vh;
  top:-20px;
  left:-320px;
  transition:all 0.5s;
}
.side_menu_banner {
  padding:18px 0;
  background: white;
  border-bottom:1px solid rgb(226, 226, 226);
}
.side_menu_banner > img {
  width:180px;
}
.side_menu_list>ul{
  list-style-type:none;
  margin:0;
  padding:0;
}
.side_menu_list>ul>a {
  display:block;
  padding:10px 20px;
  font-size:21px;
  color:#00a0e9;
  text-decoration:none;
}
.side_menu_list>ul>a:hover {
  color:#ff45cd;
}

@media (max-width:1200px){
  #nav-menu-container,
  .header_item_right {
    display: none;
  }
  #nav_flex_blcok {
    justify-content: center;
  }
  .top_menu_btn {
    display:flex;
  }
}

/* Mobile Nav Toggle
#mobile-nav-toggle {
  left: 2%;
  z-index: 998;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: none;
  font-size: 1.8rem;
  display: none;
  transition: all 0.4s;
  outline: none;
  cursor: pointer;
  position: absolute;
}
#mobile-nav-toggle i {
  color: #222;
  font-weight: 900;
}
@media (max-width: 1200px) {
  #nav_flex_blcok {
    justify-content: center;
  }
  #mobile-nav-toggle {
    display: block;
  }
}
/* Mobile Nav Styling
#mobile-nav {
  position: fixed;
  top: 0;
  padding-top: 18px;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.8);
  left: -180px;
  width: 180px;
  overflow-y: auto;
  transition: 0.4s;
}
#mobile-nav ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
#mobile-nav ul li {
  position: relative;
}
#mobile-nav ul li a {
  color: #fff;
  font-size: 1rem;
  text-transform: uppercase;
  overflow: hidden;
  padding: 10px 22px 10px 15px;
  position: relative;
  text-decoration: none;
  width: 100%;
  display: block;
  outline: none;
}
#mobile-nav ul li a:hover {
  color: #8490ff;
}
#mobile-nav ul li li {
  padding-left: 30px;
}
#mobile-nav ul li ul {
  display: none;
}
#mobile-nav ul .menu-has-children i {
  position: absolute;
  right: 0;
  z-index: 0;
  padding: 15px;
  color: #fff;
}
#mobile-nav ul .menu-has-children i.fa-chevron-up {
  color: #8490ff;
}
#mobile-nav ul .menu-has-children li a {
  text-transform: none;
}
#mobile-nav ul .menu-item-active {
  color: #8490ff;
}
#mobile-body-overly {
  width: 100%;
  height: 100%;
  z-index: 9998;
  top: 0;
  left: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.7);
  display: none;
}
/* Mobile Nav body classes
body.mobile-nav-active {
  overflow: hidden;
}
body.mobile-nav-active #mobile-nav {
  left: 0;
}
body.mobile-nav-active #mobile-nav-toggle {
  color: #fff;
} */

/*Footer*/
footer {
  background-color: #3e3a39;
  text-align: center;
  color: #fff;
  line-height: 1.8;
}
.footer_icon {
  margin: 5px;
  max-width: 60px;
  transition: all 0.2s;
}
.footer_icon:hover {
  transform: scale(1.2);
}
.footer_copyRight_blcok {
  font-size: 14px;
  font-weight: 500;
}

.company_info p:hover {
  color:gainsboro;
  cursor:default;
}
</style>


<script>
import Home from "@/components/home";

export default {
  name: "App",
  components: {
    Home
  },
  created() {
    this.$http.get("https://randomuser.me/api/").then(response => {
      console.log(response.data);
    });
  }
};
</script>

<!--
<script>

            $(document).ready(function(){
                if ($('#nav-menu-container').length) {
                    var $mobile_nav = $('#nav-menu-container').clone().prop({
                        id: 'mobile-nav'
                    });
                    $mobile_nav.find('> ul').attr({
                        'class': '',
                        'id': ''
                    });
                    $('body').append($mobile_nav);
                    $('body').append('<div id="mobile-body-overly"></div>');
                    $('#nav_flex_blcok').prepend('<button type="button" id="mobile-nav-toggle"><i class="lnr lnr-menu"></i></button>');
                    $('#mobile-nav').find('.menu-has-children').prepend('<i class="lnr lnr-chevron-down"></i>');

                    $(document).on('click', '#mobile-nav .menu-has-children a', function(e) {
                        $(this).toggleClass('menu-item-active');
                        $(this).nextAll('ul').eq(0).slideToggle();
                        $('.menu-has-children i').toggleClass("lnr-chevron-up lnr-chevron-down");
                    });

                    $(document).on('click', '#mobile-nav-toggle', function(e) {
                        $('body').toggleClass('mobile-nav-active');
                        $('#mobile-nav-toggle i').toggleClass('lnr-cross lnr-menu');
                        $('#mobile-body-overly').toggle();
                    });

                    $(document).on('click', function(e) {
                        var container = $("#mobile-nav, #mobile-nav-toggle");
                        if (!container.is(e.target) && container.has(e.target).length === 0) {
                            if ($('body').hasClass('mobile-nav-active')) {
                                $('body').removeClass('mobile-nav-active');
                                $('#mobile-nav-toggle i').toggleClass('lnr-cross lnr-menu');
                                $('#mobile-body-overly').fadeOut();
                            }
                        }
                    });

                    /*$(document).on('click', '#mobile-nav ul li a', function(e) {
                        $('#mobile-body-overly').toggle();
                    });*/



                } else if ($("#mobile-nav, #mobile-nav-toggle").length) {
                    $('#mobile-body-overly').fadeOut();

                }


            });



        </script>
-->



// WEBPACK FOOTER //
// src/main.vue